import { disablePageScroll, enablePageScroll } from "scroll-lock";
const hamburger = document.querySelector(".hamburger");
const nav__menu = document.querySelector(".nav__menu");


const nav = () => {
hamburger.addEventListener("click", () => {
  hamburger.classList.toggle("is-active");
  nav__menu.classList.toggle("is-active");
  if (hamburger.classList.contains("is-active")) {
    hamburger.setAttribute("aria-expanded", "true");
    nav__menu.setAttribute("aria-hidden", "false");
    disablePageScroll();
  } else {
    hamburger.setAttribute("aria-expanded", "false");
    nav__menu.setAttribute("aria-hidden", "true");
    enablePageScroll();
  }
});



//prevent transitions on resize
let resizeTimer;
window.addEventListener("resize", () => {
  document.body.classList.add("resize-animation-stopper");
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    document.body.classList.remove("resize-animation-stopper");
  }, 400);
});

}
export default nav;